import React, { Component } from "react"

export default class KstRDynamics extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">KstR Dynamics</p>
            <p className="portdesctext">Identified the molecular mechanism of KstR, a Mycobacterium tuberculosis transcriptional regulator. Worked alongsite structural biologists to elucidate the proeins behaviour in complex with DNA or ligand.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href='https://www.dropbox.com/s/gaxe39mbwqr2x7c/master_thesis.pdf?dl=0' target="_blank" rel="noopener noreferrer"><p className="linktext">PDF</p></a>
        </div>
      </div>
  )
}
}

